import React from 'react'
import { Space, Tooltip } from 'antd'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconTrash } from '../../../../shared/components/icons/IconTrash'
import { IconReportAi } from '../../../../shared/components/icons/IconReportAi'
import { IconEdit2 } from '../../../../shared/components/icons/IconEdit2'
import { IconArrowRight } from '../../../../shared/components/icons/IconArrowRight'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { BpPopconfirm } from '../../../../shared/components/cards/popconfirm/BpPopconfirm'
import { DropOptions } from '../../../../shared/components/forms/drop-options/DropOptions'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePostProjectDeleteDemoProjectMutation } from '../../../../app/api'

interface ActionsCellProps {
  id: number
  status: string
  is_demo: boolean
  index: number
}

export const ActionsCell = ({ id, status, is_demo, index }: ActionsCellProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [deleteDemoProject] = usePostProjectDeleteDemoProjectMutation()

  const archived = status === 'Archived'
  const showIndicator = index == 0 && !localStorage.getItem('show-report') && !archived

  if (is_demo) {
    return (
      <Space>
        <BpPopconfirm
          arrowPointAtCenter
          okButtonProps={{
            iconLeft: <IconTrash className={'stroke-0'} color={'#FFF'} />,
            theme: 'danger',
          }}
          cancelText={t('buttons.cancel')}
          okText={t('buttons.delete')}
          overlayClassName={'w-[260px]'}
          placement={'bottomRight'}
          theme={'light'}
          title={t('pages.projects.deleteDemoProject')}
          onConfirm={() => deleteDemoProject()}
        >
          <IconButton size='lg'>
            <IconTrash color='#00326D' />
          </IconButton>
        </BpPopconfirm>
      </Space>
    )
  }

  return (
    <Space>
      <DropOptions
        options={[
          {
            text: t('pages.projects.buttons.advertisers'),
            value: 'ad-reports',
            icon: <IconArrowRight color={'#00326d'} />,
          },
          {
            text: t('pages.projects.buttons.affiliates'),
            value: 'ppc-compliance',
            icon: <IconArrowRight color={'#00326d'} />,
          },
        ]}
        horizontalPosition={'right'}
        onChange={(value) => {
          localStorage.setItem('show-report', 'true')
          navigate(`/${value}?project=${id}`)
        }}
      >
        <Tooltip
          placement={'topRight'}
          title={t('buttons.other.goToAdvertisersOrAffiliatesReportTooltip')}
        >
          <div>
            <BpButton
              disabled={archived}
              iconLeft={<IconReportAi color={archived ? '#6684A7' : '#00326d'} />}
              size={'sm'}
              theme={'outline'}
            >
              <span className={archived ? '!text-aqua-300' : '!text-focus-600'}>
                {t('pages.projects.buttons.reportMenu')}
              </span>
              {showIndicator && (
                <span
                  className={
                    'absolute top-[-6px] left-[-6px] h-[12px] w-[12px] rounded-full bg-danger'
                  }
                ></span>
              )}
            </BpButton>
          </div>
        </Tooltip>
      </DropOptions>
      <Tooltip placement={'topRight'} title={t('buttons.other.editMonitoringSettingsTooltip')}>
        <div>
          <IconButton size='lg' onClick={() => navigate(`/projects/${id}`)}>
            <IconEdit2 color='#00326D' />
          </IconButton>
        </div>
      </Tooltip>
    </Space>
  )
}
